import { useEffect, useRef } from 'react';
import {
  fireShiftRequestMissingInfoPopupViewed,
  type IShiftRequestMissingInfoPayload,
} from '~/posthogs/events';

/**
 * Fires `missing_info_popup:viewed` once per closed → open, not per mount (StrictMode double-runs
 * effects in development). The payload ref is refreshed in an effect, not during render, and that
 * effect runs first.
 */
export const useTrackMissingInfoViewed = (
  isOpen: boolean,
  payload: IShiftRequestMissingInfoPayload,
): void => {
  const payloadRef = useRef(payload);
  useEffect(() => {
    payloadRef.current = payload;
  });

  const wasOpenRef = useRef(false);
  useEffect(() => {
    if (isOpen && !wasOpenRef.current) {
      fireShiftRequestMissingInfoPopupViewed(payloadRef.current);
    }
    wasOpenRef.current = isOpen;
  }, [isOpen]);
};
